import { Dispatch } from "redux"
import {
  ALL_FIELDS_REQUIRED,
  INVALID_PREFIX_URL,
  LARGE_NAME,
  LARGE_PREFIX_URL,
  PRODUCTS_HTTP_ERR_RESPONSES_MESSAGES
} from "constants/products-responses"
import { CLOSE_MODAL } from "./actions-types"
import { validatePrefixUrl } from "utils/auth/authHelper"

export class ProductValidations {
  response(status: number, dispatch: Dispatch) {
    if (status >= 100 && status < 300) {
      dispatch({ type: CLOSE_MODAL })
    }

    const code = status as keyof typeof PRODUCTS_HTTP_ERR_RESPONSES_MESSAGES

    return PRODUCTS_HTTP_ERR_RESPONSES_MESSAGES[code]
  }

  // verificar campos vazios reeditados
  isInvalidCreateInput(data: App.Product) {
    const { name, prefixUrl } = data

    if (!name || !prefixUrl) return { isInvalid: true, msg: ALL_FIELDS_REQUIRED }
    if (!validatePrefixUrl(prefixUrl)) return { isInvalid: true, msg: INVALID_PREFIX_URL }
    if (prefixUrl.length > 30) return { isInvalid: true, msg: LARGE_PREFIX_URL }
    if (name.length > 50) return { isInvalid: true, msg: LARGE_NAME }

    return { isInvalid: false, msg: "" }
  }

  updateMapper(actual: App.Product, previous: App.Product) {
    const product = {
      name: actual.name,
      prefixUrl: actual.prefixUrl,
      isFederated: actual.isFederated,
      federatedKey: actual.federatedKey,
      federationFields: actual.federationFields
    }

    if (!actual.name || actual.name === "") product.name = previous.name
    if (!actual.prefixUrl || actual.prefixUrl === "") product.prefixUrl = previous.prefixUrl

    return product
  }

  isInvalidUpdateInput(actual: App.Product) {
    const { name, prefixUrl } = actual

    if (!validatePrefixUrl(prefixUrl))
      return {
        isInvalid: true,
        msg: INVALID_PREFIX_URL
      }
    if (prefixUrl.length > 30) return { isInvalid: true, msg: LARGE_PREFIX_URL }
    if (name.length > 50) return { isInvalid: true, msg: LARGE_NAME }

    return { isInvalid: false, msg: "" }
  }
}
